import { useEffect, useState } from 'react'
import { getDurationNumberFormat } from 'Utils/func'

const useCountdown = (deadlineMilli: number, startTimeMilli?: number) => {
  const [isExpired, setIsExpired] = useState(true)
  const [isStarted, setIsStarted] = useState(false)
  const [dd, setDd] = useState('0')
  const [hh, setHh] = useState('00')
  const [mm, setMm] = useState('00')
  const [ss, setSs] = useState('00')

  useEffect(() => {
    if (!deadlineMilli) return
    // 更新倒计时
    const updateTimer = () => {
      const now = Date.now()

      // 检查是否在时间范围内
      if (startTimeMilli && now < startTimeMilli) {
        setIsStarted(false)
        setIsExpired(true)
        return
      }

      setIsStarted(true)
      const diff = Math.max(0, (deadlineMilli - now) / 1000)

      setDd(getDurationNumberFormat(diff, 'd'))
      setHh(getDurationNumberFormat(diff, 'h'))
      setMm(getDurationNumberFormat(diff, 'm'))
      setSs(getDurationNumberFormat(diff, 's'))

      // 判断是否需要显示倒计时
      if (diff <= 0) {
        setIsExpired(true)
        clearInterval(timer)
      } else {
        setIsExpired(false)
      }
    }

    // 每秒更新倒计时
    const timer = setInterval(updateTimer, 1000)

    // 初始化时立即执行一次更新
    updateTimer()

    // 清理计时器
    return () => clearInterval(timer)
  }, [deadlineMilli, startTimeMilli])

  return { isExpired, isStarted, dd, hh, mm, ss }
}

export default useCountdown
